//@flow
import { compose } from 'recompose'
import { ModalBody, ModalHeader, Button } from 'reactstrap'
import { connect } from 'react-redux'

import { optionsResumeRMS } from './constants'
import RadioButton from '../../../common-components/radio-button-group'
import { getRemoteSellingState } from 'e-submission/domain/data-model/form/selectors'
import { getCurrentApp } from '../../apps/selectors'
import { setRemoteSellingResumeState, closeRemoteSellingResumeModal } from '../../apps/actions'
import { Modal } from '../../../common-components'
import type { AppState } from 'quick-quote/reducers'
import { submitRemoteSellingSubmitResumeModal } from 'core/actions'

const SendLinkButton = (props) => {
  const { resumeState, submitModal } = props
  return (
    <div style={{ textAlign: 'center' }}>
      <Button
        color={!resumeState ? 'disabled' : 'primary'}
        className="primary"
        onClick={() => {
          if (!resumeState) return null
          submitModal()
        }}
      >
        ยืนยัน
      </Button>
    </div>
  )
}

const TitleDescription = (props) => {
  const { resumeState } = props
  if (!resumeState || resumeState === optionsResumeRMS[0].value) return null

  let text = 'ระบบจะส่งลิงก์เดิมที่ลูกค้าเคยดำเนินการกรอกข้อมูลใบคำขอค้างไว้'

  if (resumeState === optionsResumeRMS[2].value)
    text = 'ระบบจะดำเนินการส่งลิงก์ใหม่ให้กับลูกค้าเพื่อทำการยืนยันตัวตนใหม่อีกครั้ง'

  return (
    <div
      style={{ minWidth: '100%' }}
      className="validation-message attached-icon info-message-wrap form-control-feedback"
    >
      <p>{text}</p>
    </div>
  )
}

const manageResumeRmsOptions = (sectionName) => {
  try {
    if (sectionName === 'videoConsent') {
      return optionsResumeRMS.filter((option) => {
        return option.value !== 'createLink'
      })
    }
    return [...optionsResumeRMS]
  } catch (e) {
    console.error(`manageResumeRmsOptions :`, e.message)
  }
}

export const ResumeRMS = ({ closeModal, setMethod, validateInput, resumeState, isOpen, submitModal, sectionName }) => {
  const isInvalid = validateInput && !validateInput.isOk
  const options = manageResumeRmsOptions(sectionName)
  return (
    <Modal isOpen={isOpen} backdrop={true} size="md" modalClassName="default-bootstrap remote-selling-modal">
      <ModalHeader
        toggle={() => {
          closeModal()
        }}
      >
        ท่านต้องการกลับสู่การขายด้วยระบบ Remote Selling
      </ModalHeader>
      <ModalBody>
        <div className={`form-group ${isInvalid ? 'has-danger' : ''}`}>
          <RadioButton options={options} value={resumeState} onChange={(e) => setMethod(e)} />
          <TitleDescription resumeState={resumeState} />
        </div>
        <SendLinkButton
          resumeState={resumeState}
          submitModal={() => {
            submitModal(sectionName)
          }}
        />
      </ModalBody>
    </Modal>
  )
}

const mapStateToResumeRMS = (state: AppState) => {
  const app = getCurrentApp(state)
  const remoteSellingState = getRemoteSellingState(app)
  return {
    resumeState: remoteSellingState.resumeState,
    insuredOrPayer: null,
    isOpen: remoteSellingState.isResendModalOpen,
    openModal: () => {},
    onExit: () => {},
    method: remoteSellingState.sendingMethod,
  }
}

const mapDispatchToResumeRMS = (dispatch: Dispatch<*>) => ({
  setMethod: (value) => dispatch(setRemoteSellingResumeState(value)),
  closeModal: () => dispatch(closeRemoteSellingResumeModal()),
  submitModal: (sectionName) => dispatch(submitRemoteSellingSubmitResumeModal(sectionName)),
})

export default compose(connect(mapStateToResumeRMS, mapDispatchToResumeRMS))(ResumeRMS)
